import { supportApi } from "../api";

export type ScreenRelayRole = "host" | "viewer" | "observer";

export async function openScreenRelay(role: ScreenRelayRole, sessionId?: number): Promise<WebSocket> {
  const grant = await supportApi.relayTicket(role, sessionId);
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const url = new URL("/api/v1/support/screen-relay", window.location.href);
  url.protocol = protocol;
  url.searchParams.set("ticket", grant.token);
  const socket = new WebSocket(url);
  socket.binaryType = "blob";
  await new Promise<void>((resolve, reject) => {
    const opened = () => { window.clearTimeout(timeout); socket.removeEventListener("error", failed); resolve(); };
    const failed = () => { window.clearTimeout(timeout); socket.removeEventListener("open", opened); reject(new Error("The secure support relay could not be opened.")); };
    const timeout = window.setTimeout(() => { socket.removeEventListener("open", opened); socket.removeEventListener("error", failed); socket.close(); reject(new Error("The secure support relay did not respond.")); }, 10_000);
    socket.addEventListener("open", opened, { once: true });
    socket.addEventListener("error", failed, { once: true });
  });
  return socket;
}

export function readRelayMessage(value: unknown): Record<string, unknown> | undefined {
  if (typeof value !== "string") return undefined;
  try { return JSON.parse(value) as Record<string, unknown>; }
  catch { return undefined; }
}
